
import CloudLightning from "../../../assets/outline/CloudLightning.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudLightningIcon({ className, dataTestid = "CloudLightningIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudLightning data-testid={dataTestid} className={classes} {...rest} />
  );
}
